import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, DatePicker, Select, Button, Row, Col } from 'antd';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import { API_BASE_URL } from '../../config';

const { Option } = Select;
const defaultTime = { defaultValue: dayjs().hour(6).minute(0).second(0) };

const EditBasicInformation = ({ visible, onCancel, id, editingBasicInfo, relation = 'student' }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [formPhoto, setFormPhoto] = useState("");
  const [idCopyFile, setIDCopyFile] = useState("");
//  const [gender, setGender] = useState("");
  
  const [genderOptions, setGenderOptions] = useState([]);

  // Define Gender enum locally to match backend exactly
  const Gender = {
    0: 'Male',
    1: 'Female',
    2: 'Other'
  };

  // Convert enum to options format with numeric values
  const genderOptionsLocal = Object.entries(Gender).map(([value, label]) => ({
    value: Number(value), // Ensure numeric value
    label
  }));

  useEffect(() => {
    setGenderOptions(genderOptionsLocal);
    console.log('editingBasicInfo.gender',editingBasicInfo.gender);
    if (visible && editingBasicInfo) {
      const formData = {
        FirstName: editingBasicInfo.firstName || 'N/A',
        SurName: editingBasicInfo.surName || 'N/A',
        LastName: editingBasicInfo.lastName || 'N/A',
        Email: editingBasicInfo.email || 'N/A',
        PhoneNumber: editingBasicInfo.phoneNumber || 'N/A',
        DOB: editingBasicInfo.dob ? dayjs(editingBasicInfo.dob) : dayjs().hour(6).minute(0).second(0),
        Gender: Number(editingBasicInfo.gender || 0), // Ensure numeric value
        Nationality: editingBasicInfo.nationality || 'N/A',
        BirthCountry: editingBasicInfo.birthCountry || 'N/A',
        IDInformationCountry: editingBasicInfo.idInformationCountry || 'N/A',
        IDNumber: editingBasicInfo.idNumber || 'N/A',
        IDCopyFile: editingBasicInfo.idCopyFile ? `data:image/jpeg;base64,${editingBasicInfo.idCopyFile}` : '',
        Photo: editingBasicInfo.photo ? `data:image/jpeg;base64,${editingBasicInfo.photo}` : ''
      };

      console.log('Setting form data with gender:', formData.Gender); // Debug log
//      form.setFieldsValue(formData);

      form.setFieldsValue({
        ...formData,
        gender: formData.Gender // Set the gender directly
      });

      setFormPhoto(formData.Photo || '');
      setIDCopyFile(formData.IDCopyFile || '');
  //    setGender(formData.gender || '');
    }
  }, [visible, editingBasicInfo, form]);

  const handleGenderChange= async (value) => {
    console.log('value',value);
    form.setFieldsValue({ gender: value });

  };

  const handleFileChange = async (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      const file = files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result; // This will be a Data URL

        if (name === 'IDCopyFile') {
          setIDCopyFile(base64String);
        } else if (name === 'Photo') {
          setFormPhoto(base64String);
        }
      };

      reader.onerror = (error) => {
        console.error("File reading error:", error);
        toast.error("An error occurred while reading the file");
      };

      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const dobDate = values.DOB || dayjs().hour(6).minute(0).second(0);
      const formattedDate = dobDate.format('YYYY-MM-DDTHH:mm:ss');

      // Create an object to hold data
      const jsonData = {
        FirstName: values.FirstName,
        SurName: values.SurName,
        LastName: values.LastName,
        Email: values.Email,
        PhoneNumber: values.PhoneNumber,
        DOB: formattedDate,
        Gender: Number(values.gender), // Ensure numeric value
        Nationality: values.Nationality,
        BirthCountry: values.BirthCountry,
        IDInformationCountry: values.IDInformationCountry,
        IDNumber: values.IDNumber,
        IDCopyFile: idCopyFile.split(',')[1] || '', // Extract base64 part
        Photo: formPhoto.split(',')[1] || '', // Extract base64 part
      };

      console.log('Submitting JSON data:', jsonData); // Debug log

      const endpoint = relation.toLowerCase() === 'parent' 
        ? `/api/BasicPersonalInformation/editBasicPersonalInformation-parent/${editingBasicInfo.id}`
        : `/api/BasicPersonalInformation/editBasicPersonalInformation-student/${editingBasicInfo.studentId}`;
      console.log('endpoint',endpoint);
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(jsonData),
      });

      let errorMessage = '';
      let responseData = null;

      try {
        responseData = await response.json();
        console.log('Response data:', responseData); // Debug log
        errorMessage = responseData.message || 'An error occurred while updating the information';
      } catch (e) {
        errorMessage = response.statusText || 'An error occurred while updating the information';
      }

      if (!response.ok) {
        throw new Error(errorMessage);
      }

      toast.success(`${relation.charAt(0).toUpperCase() + relation.slice(1)} information updated successfully!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      onCancel();
    } catch (error) {
      console.error(`Error updating ${relation}:`, error);
      toast.error(error.message || `Failed to update ${relation} information`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <Modal
      visible={visible}
      title={`Edit ${relation.charAt(0).toUpperCase() + relation.slice(1)} Basic Information`}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleSubmit}>
          Save Changes
        </Button>
      ]}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="FirstName"
              label="First Name"
              rules={relation.toLocaleLowerCase() === 'parent' ? [{ required: true, message: 'Please enter first name' }] : []}

            >
              <Input readOnly={relation.toLocaleLowerCase() === 'student'} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="SurName"
              label="Sur Name (middle name)"
              rules={relation.toLocaleLowerCase() === 'parent' ? [{ required: true, message: 'Please enter middle name' }] : []}
              >
              <Input readOnly={relation.toLocaleLowerCase() === 'student'} />
              </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="LastName"
              label="Last Name (Grand father name)"
              rules={relation.toLocaleLowerCase() === 'parent' ? [{ required: true, message: 'Please enter last name' }] : []}
            >
              <Input readOnly={relation.toLocaleLowerCase() === 'student'} />
              </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="Email"
              label="Email"
              rules={[
                { required: true, message: 'Please enter email' },
                { type: 'email', message: 'Please enter a valid email' }
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="PhoneNumber"
              label="Phone Number"
              rules={[{ required: true, message: 'Please enter phone number' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="DOB"
              label="Date of Birth"
              rules={[{ required: true, message: 'Please select date of birth' }]}
            >
              <DatePicker 
                showTime={defaultTime}
                format="YYYY-MM-DD HH:mm:ss"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="gender"
              label="Gender"
               
              rules={[{ required: true, message: 'Please select gender' }]}
            >
              <Select
               placeholder="Select gender"
               onChange={handleGenderChange}
              >             
                {genderOptions.map(option => (
                  <Option key={option.key} value={Number(option.value)}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="Nationality"
              label="Nationality"
              rules={[{ required: true, message: 'Please enter nationality' }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="BirthCountry"
              label="Birth Country"
              rules={[{ required: true, message: 'Please enter birth country' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="IDInformationCountry"
              label="ID Information Country"
              rules={[{ required: true, message: 'Please enter ID information country' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="IDNumber"
              label="ID Number"
              rules={[{ required: true, message: 'Please enter ID number' }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="IDCopyFile" label="ID Copy">
              <input
                type="file"
                name="IDCopyFile"
                onChange={handleFileChange}
                accept=".pdf,.jpg,.jpeg,.png"
              />
              {idCopyFile && (
                <img
                  src={idCopyFile} // Displaying the image directly from the base64 string
                  alt="ID Copy Preview"
                  style={{ width: '100%', marginTop: '10px' }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="Photo" label="Photo">
              <input
                type="file"
                name="Photo"
                onChange={handleFileChange}
                accept=".pdf,.jpg,.jpeg,.png"
              />
              {formPhoto && (
                <img
                  src={formPhoto} // Displaying the image directly from the base64 string
                  alt="Photo Preview"
                  style={{ width: '100%', marginTop: '10px' }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditBasicInformation;